module.exports = __webpack_public_path__ + "img/ACA_Sample_Certificate.cb5934d5.png";